export const kornFerrySkills = [
  // Leadership & Navigation
  {
    id: 1,
    titleFr: 'Assurer la Responsabilité',
    titleEn: 'Ensures Accountability',
    description:
      "Tenir les gens responsables; gérer et mesurer le travail; faire preuve d'engagement organisationnel.",
    category: 'leadership',
  },
  {
    id: 10,
    titleFr: 'Courage',
    titleEn: 'Courage',
    description:
      'Compétences de commandement; courage managérial; confiance en soi; faire face aux problèmes.',
    category: 'leadership',
  },
  {
    id: 15,
    titleFr: 'Diriger le Travail',
    titleEn: 'Directs Work',
    description:
      'Délégation; diriger les autres; faire accomplir le travail par les autres.',
    category: 'leadership',
  },
  {
    id: 16,
    titleFr: "Favoriser l'Engagement",
    titleEn: 'Drives Engagement',
    description:
      'Motiver les autres; inspirer et engager; inspirer les autres.',
    category: 'leadership',
  },
  {
    id: 34,
    titleFr: 'Bâtir des Équipes Efficaces',
    titleEn: 'Builds Effective Teams',
    description:
      'Bâtir des équipes à forte identité qui appliquent leurs compétences et perspectives diverses pour atteindre des objectifs communs; Inspirer les autres.',
    category: 'leadership',
  },
  {
    id: 36,
    titleFr: 'Inspirer Confiance',
    titleEn: 'Instills Trust',
    description:
      'Intégrité et confiance; éthique et valeurs; établir la confiance.',
    category: 'leadership',
  },
  {
    id: 37,
    titleFr: "Incarner la Vision et l'Objectif",
    titleEn: 'Drives Vision and Purpose',
    description: "Gérer la vision et le but; leadership d'équipe.",
    category: 'leadership',
  },

  // Thought
  {
    id: 5,
    titleFr: 'Sens des Affaires',
    titleEn: 'Business Insight',
    description:
      "Avoir du flair commercial; comprendre le fonctionnement de l'entreprise; perspective d'affaires.",
    category: 'thought',
  },
  {
    id: 8,
    titleFr: 'Gérer la Complexité',
    titleEn: 'Manages Complexity',
    description:
      'Donner du sens à des informations complexes, en grande quantité et parfois contradictoires pour résoudre efficacement les problèmes.',
    category: 'thought',
  },
  {
    id: 12,
    titleFr: 'Qualité des Décisions',
    titleEn: 'Decision Quality',
    description: 'Jugement; prise de décision opportune; capacité de décision.',
    category: 'thought',
  },
  {
    id: 17,
    titleFr: 'Sens Financier',
    titleEn: 'Financial Acumen',
    description:
      'Acuité financière et quantitative; orientation vers les résultats financiers.',
    category: 'thought',
  },
  {
    id: 18,
    titleFr: 'Perspective Globale',
    titleEn: 'Global Perspective',
    description:
      'Avoir une perspective large; perspicacité culturelle des affaires; pensée de leadership mondial.',
    category: 'thought',
  },
  {
    id: 19,
    titleFr: "Cultive l'Innovation",
    titleEn: 'Cultivates Innovation',
    description: "Créativité; gestion de l'innovation; pensée conceptuelle.",
    category: 'thought',
  },
  {
    id: 33,
    titleFr: 'Esprit Stratégique',
    titleEn: 'Strategic Mindset',
    description:
      'Agilité stratégique; pensée stratégique; alignement stratégique.',
    category: 'thought',
  },
  {
    id: 35,
    titleFr: 'Maîtrise Technologique',
    titleEn: 'Tech Savvy',
    description: 'Apprentissage technique (Technical Learning).',
    category: 'thought',
  },

  // Results
  {
    id: 2,
    titleFr: "Axé sur l'Action",
    titleEn: 'Action Oriented',
    description:
      "Faire preuve d'énergie et d'initiative; se concentrer sur les résultats financiers; prendre des initiatives à tous les niveaux.",
    category: 'results',
  },
  {
    id: 4,
    titleFr: 'Attirer les Meilleurs Talents',
    titleEn: 'Attracts Top Talent',
    description:
      'Embaucher et doter en personnel; évaluer les gens; prendre des décisions difficiles concernant les personnes.',
    category: 'results',
  },
  {
    id: 11,
    titleFr: 'Orientation Client',
    titleEn: 'Customer Focus',
    description: 'Se concentrer sur le client; gérer les relations diverses.',
    category: 'results',
  },
  {
    id: 13,
    titleFr: 'Développer les Talents',
    titleEn: 'Develops Talent',
    description:
      'Développer les rapports directs et les autres; amélioration des talents; développement des personnes.',
    category: 'results',
  },
  {
    id: 25,
    titleFr: 'Planifier et Aligner',
    titleEn: 'Plans and Aligns',
    description:
      'Planification et organisation; établissement des priorités; pensée analytique concernant la planification du travail.',
    category: 'results',
  },
  {
    id: 27,
    titleFr: 'Débrouillardise',
    titleEn: 'Resourcefulness',
    description:
      "S'organiser; exécution; astuce politique (conscience organisationnelle).",
    category: 'results',
  },
  {
    id: 28,
    titleFr: 'Obtenir des Résultats',
    titleEn: 'Drives Results',
    description:
      'Orientation vers les résultats; se concentrer sur le résultat net; obtenir des résultats (Gets Results).',
    category: 'results',
  },
  {
    id: 38,
    titleFr: 'Optimiser les Processus',
    titleEn: 'Optimizes Work Processes',
    description:
      'Gestion des processus; gestion par les systèmes; amélioration continue de la qualité/performance.',
    category: 'results',
  },

  // Self
  {
    id: 3,
    titleFr: "Gérer l'Ambigüité",
    titleEn: 'Manages Ambiguity',
    description:
      "Gérer le changement et la flexibilité; faire face à l'incertitude.",
    category: 'self',
  },
  {
    id: 6,
    titleFr: 'Collaborer',
    titleEn: 'Collaborates',
    description:
      "Travail d'équipe et collaboration; relations avec les pairs; exploiter les réseaux.",
    category: 'self',
  },
  {
    id: 7,
    titleFr: 'Communiquer Efficacement',
    titleEn: 'Communicates Effectively',
    description:
      'Écoute active; compétences de présentation et communication écrite; communication ouverte.',
    category: 'self',
  },
  {
    id: 9,
    titleFr: 'Gérer les Conflits',
    titleEn: 'Manages Conflict',
    description: 'Gestion des conflits; faire face aux problèmes.',
    category: 'self',
  },
  {
    id: 14,
    titleFr: 'Valoriser les Différences',
    titleEn: 'Values Differences',
    description:
      'Gérer la diversité; comprendre les autres; valoriser la diversité culturelle.',
    category: 'self',
  },
  {
    id: 20,
    titleFr: 'Savoir-faire Interpersonnel',
    titleEn: 'Interpersonal Savvy',
    description:
      'Entrer en relation ouvertement et confortablement avec divers groupes de personnes; Bâtir des relations.',
    category: 'self',
  },
  {
    id: 21,
    titleFr: 'Construire des Réseaux',
    titleEn: 'Builds Networks',
    description:
      'Savoir-faire politique; bâtir des relations; tirer parti des réseaux.',
    category: 'self',
  },
  {
    id: 22,
    titleFr: 'Apprentissage Rapide/Agile',
    titleEn: 'Nimble Learning',
    description:
      "Apprendre à la volée (Learning on the fly); prédisposition à l'apprentissage.",
    category: 'self',
  },
  {
    id: 23,
    titleFr: 'Savoir-faire Organisationnel',
    titleEn: 'Organizational Savvy',
    description:
      'Agilité organisationnelle; gérer vers le haut (confort avec la haute direction); astuce politique.',
    category: 'self',
  },
  {
    id: 24,
    titleFr: 'Persuader',
    titleEn: 'Persuades',
    description: "Négociation; influence; impact par l'influence.",
    category: 'self',
  },
  {
    id: 26,
    titleFr: 'Être Résilient',
    titleEn: 'Being Resilient',
    description: 'Sang-froid (Composure); persévérance; maîtrise de soi.',
    category: 'self',
  },
  {
    id: 29,
    titleFr: 'Conscience de Soi',
    titleEn: 'Demonstrates Self-Awareness',
    description:
      'Connaissance de soi; divulgation personnelle (Personal Disclosure).',
    category: 'self',
  },
  {
    id: 30,
    titleFr: 'Auto-Développement',
    titleEn: 'Self-Development',
    description:
      'Développement personnel; démontrer une flexibilité personnelle.',
    category: 'self',
  },
  {
    id: 31,
    titleFr: 'Adaptabilité Situationnelle',
    titleEn: 'Situational Adaptability',
    description:
      'Apprentissage personnel; gérer les paradoxes; adaptabilité/flexibilité.',
    category: 'self',
  },
  {
    id: 32,
    titleFr: 'Équilibrer les Parties Prenantes',
    titleEn: 'Balances Stakeholders',
    description:
      'Anticiper et équilibrer les besoins de multiples parties prenantes; Compréhension interpersonnelle; responsabilité sociale.',
    category: 'self',
  },
]

export const getCategoryLabel = (category: string) => {
  switch (category) {
    case 'leadership':
      return 'Leadership & Navigation'
    case 'thought':
      return 'Réflexion Stratégique'
    case 'results':
      return 'Obtention de Résultats'
    case 'self':
      return 'Développement Personnel'
    default:
      return category
  }
}

export const getCategoryColor = (category: string) => {
  switch (category) {
    case 'leadership':
      return 'bg-blue-100 text-blue-900'
    case 'thought':
      return 'bg-purple-100 text-purple-900'
    case 'results':
      return 'bg-green-100 text-green-900'
    case 'self':
      return 'bg-amber-100 text-amber-900'
    default:
      return 'bg-gray-100 text-gray-900'
  }
}
